module.exports = __webpack_public_path__ + "img/米兰柏羽.b45a61e.png";